import adresseGenerer from '@/services/general/genererAdresse';
import { CATEGORIE_ECRAN_NUMERIQUE } from '@/configuration/catalogue/produitConf';
import entiteCommercialeGenerer from '@/services/entiteCommerciale/genererEntiteCommerciale';
import { SENS_VENTE } from '@/configuration/devisConf';
import getSupportCommercial from './getSupportCommercial';

export default async function genererProduitNumerique() {
  const supportCommerical = await getSupportCommercial(CATEGORIE_ECRAN_NUMERIQUE);
  return {
    reference: null,
    libelle: null,
    liaisonsTarif: [],
    supportCommercialId: supportCommerical.id,
    supportCommercial: supportCommerical,
    entiteCommerciale: entiteCommercialeGenerer(),
    schemaComptableId: null,
    schemaComptable: null,
    produitEcranNumerique: {
      codePanneau: null,
      format: null,
      materiel: null,
      azimut: null,
      adresse: adresseGenerer(),
      support: null,
      localisation: null,
      enAllantVers: null,
      enVenantDe: null,
      outdoor: false,
      angleDeVision: null,
      dureeBoucle: 60,
      dureeSpot: 10,
      dureeEntreBoucle: 0,
      nombreDiffusionJour: null,
      produitParDefautId: null,
      materielId: null,
      affimetrie: {},
      restrictionsAffichage: null,
    },
    numerique: true,
    tiersId: null,
    logisticable: true,
    compteAnalytiqueId: null,
    agenceId: null,
    controleDisponibilite: true,
    categorieGroupeProduitDeductibleId: null,
    sens: SENS_VENTE,
    categorieOperation: null,
    commissionsVendeur: [],
    objectifsVente: [],
    reglesAchat: [],
    cgvs: [],
    demandeInterventionTypes: [],
    regleFacturationId: null,
    marcheId: null,
    assistantId: null,
    commentaireVente: null,
    renouvelable: true,
  };
}
